module.exports = __webpack_public_path__ + "assets/algoritmo_mobile.aa72a8fc.svg";